<div class="lum-page invoice-client">
  <div
    class="overlay"
    lumAppLoader
    [loading]="(isLoading$ | async) || false"
    [classes]="'loading blur'"
  ></div>

  <header class="lum-page-header lum-page-header--sticky lum-page-header--card">
    <h2 class="lum-page-header__heading">
      <a [routerLink]="redirectUrl">Invoices</a> /
      <ng-container *ngIf="!(isLoading$ | async); else titleWhenLoading">
        <ng-container *ngIf="currentInvoice?.id; else titleWhenCreating">
          <a [routerLink]="['/clients/invoices', currentInvoice.id, 'view']">
            #{{ currentInvoice.id }}
          </a>
          / Edit
        </ng-container>
        <ng-template #titleWhenCreating>Create New</ng-template>
      </ng-container>
      <ng-template #titleWhenLoading>...</ng-template>
    </h2>

    <div class="lum-page-header__actions">
      <button
        *ngIf="canGenerateB2BLink"
        (click)="onGenerateB2BLink()"
        type="button"
        class="lum-button lum-button--secondary mr-2 generate-link"
        [disabled]="generatingB2BLink"
      >
        <i
          *ngIf="!generatingB2BLink; else genratingB2bLinkSpinner"
          class="fa fa-link mr-2"
        ></i>
        <ng-template #genratingB2bLinkSpinner>
          <mat-spinner class="ml-auto mr-2" [diameter]="14"></mat-spinner>
        </ng-template>
        Generate B2B Link
      </button>
      <button
        *ngIf="
          currentInvoice?.order_status === invoiceStatus.DRAFT &&
          currentInvoice?.shareable_token
        "
        (click)="copyTokenToClipboard()"
        type="button"
        class="lum-button lum-button--secondary mr-2 generate-link"
      >
        <i class="fa fa-link mr-2"></i>
        Copy B2B Portal Link
      </button>
      <button
        type="button"
        class="lum-button"
        [matMenuTriggerFor]="menu"
        [disabled]="(isLoading$ | async) || false"
      >
        <lum-ui-icon class="mr-2" icon="content-save" color="#ffffff"></lum-ui-icon>
        Save Invoice
      </button>
      <mat-menu class="lum-mat-menu" #menu="matMenu">
        <button
          *ngIf="canSaveActive$ | async"
          mat-menu-item
          (click)="onSaveInvoice(invoiceStatus.ACTIVE)"
          [disabled]="actionDisabled"
        >
          Mark as Active
        </button>
        <button
          *ngIf="canSaveCompleted$ | async"
          mat-menu-item
          (click)="onSaveInvoice(invoiceStatus.COMPLETED)"
          [disabled]="actionDisabled"
        >
          Mark as Complete
        </button>
        <ng-container *ngIf="canSaveInvoiceDraft">
          <mat-divider></mat-divider>
          <button
            *ngIf="canSaveDraft$ | async"
            mat-menu-item
            (click)="onSaveInvoice(invoiceStatus.DRAFT)"
            [disabled]="actionDisabled"
          >
            Save as Draft
          </button>
          <button
            *ngxPermissionsOnly="['invoices.create']"
            mat-menu-item
            (click)="onSaveInvoice(invoiceStatus.ESTIMATE)"
            [disabled]="actionDisabled"
          >
            Save as Estimate
          </button>
        </ng-container>

        <ng-container *ngxPermissionsOnly="['invoices.approve.company']">
          <button
            *ngIf="canRejectOrApprovePurchaseOrder"
            mat-menu-item
            (click)="onRejectInvoice()"
            [disabled]="actionDisabled"
          >
            Reject PO
          </button>

          <button
            *ngIf="canRejectOrApprovePurchaseOrder"
            (click)="onApproveInvoice()"
            mat-menu-item
            [disabled]="actionDisabled"
          >
            Approve PO
          </button>
        </ng-container>
      </mat-menu>
    </div>
  </header>

  <div class="lum-page-content">
    <lum-invoice-client-form
      #clientForm
      [form]="form"
      [companies]="companies"
      [currentCompany]="currentCompany$ | async"
      [currentWarehouseGroup]="currentWarehouseGroup"
      [shippingAddresses]="shippingAddresses"
      [warehouseGroups]="warehouseGroups"
      [loadingCompanies]="(loadingCompanies$ | async) || false"
      [contacts]="contacts"
      [countries]="countries$ | async"
      [customFieldsEnabled]="customFieldsEnabled"
      [invoiceCreatedFrom]="currentInvoice?.created_from"
      [currentInvoice]="currentInvoice"
      (selectCompanyEvent)="onSelectCompany($event)"
      (selectContactEvent)="onSelectContact($event)"
      (searchClientEvent)="onSearchClientEvent($event)"
      (clearClientEvent)="onClearClientEvent($event)"
      (scrollPaginate)="onPaginateClients()"
    ></lum-invoice-client-form>
    <div class="invoice-skus mt-8">
      <div
        class="overlay"
        lumAppLoader
        [loading]="(uploadingSku$ | async) || false"
        [classes]="'loading blur'"
      ></div>
      <ng-container *ngIf="currentCompany$ | async; else empty">
        <lum-invoice-skus
          [customFieldsEnabled]="customFieldsEnabled"
          [newKitsStructureEnabled]="newKitsStructureEnabled"
          [packageManagementEnabled]="packageManagementEnabled"
          [permissions]="permissions"
          [lotTrackingEnabled]="lotTrackingEnabled"
          [creditMemos]="creditMemos"
          [templateId]="templateId"
          [currentInvoice]="currentInvoice"
          [discountEntries]="discountEntries"
          [discountAmount]="discountAmountLineItems"
          [currentCompany]="currentCompany$ | async"
          [pricingLevels]="pricingLevels$ | async"
          [form]="form"
          [includeAllWarehouseGroups]="shouldIncludeAllWarehouseGroups"
          (selectRfq)="onSelectRfq($event)"
          (selectCreditMemo)="onSelectCreditMemo($event)"
          (removeLineItem)="onRemoveLineItem($event)"
          (removeCreditMemoEntry)="onRemoveCreditMemoEntry($event)"
          (addLineItem)="onAddLineItem($event)"
          (addRowItems)="onAddRowItems($event)"
          (addRowItemSubTotal)="onAddRowItemSubTotal($event)"
          (addInvoiceCreditMemoEntry)="onAddInvoiceCreditMemoEntry($event)"
          (recalculateSubtotals)="onRecalculateSubtotals()"
        ></lum-invoice-skus>
      </ng-container>

      <ng-template #empty>
        <lum-ui-empty-page
          class="d-block py-10"
          title="There are no SKU's to show"
          message="Please select client to show SKU table."
        ></lum-ui-empty-page>
      </ng-template>
    </div>
  </div>
</div>
